/**
 * SectionHeader — homepage section title with an optional "view all" link
 * and optional extra controls on the right.
 */
import { ChevronRight } from "lucide-react";
import { RevealWords } from "./RevealWords";
import type { ReactNode } from "react";

interface SectionHeaderProps {
  title: string;
  link?: ReactNode;
  children?: ReactNode;
}

export function SectionHeader({
  title,
  link,
  children,
}: Readonly<SectionHeaderProps>) {
  return (
    <div className="mb-8 flex items-end justify-between gap-4">
      <h2
        className="text-xlarge leading-tight font-bold tracking-[-0.01em] text-text-1 max-mobile:text-large"
        data-reveal="words"
      >
        <RevealWords text={title} />
      </h2>
      <div className="flex shrink-0 items-center gap-4">
        {link}
        {children}
      </div>
    </div>
  );
}

export const sectionLinkClass =
  "group inline-flex items-center gap-0.5 rounded-sm text-base font-semibold text-primary hover:text-primary-darker1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2";

export function SectionLinkLabel({ label }: Readonly<{ label: string }>) {
  return (
    <>
      {label}
      <ChevronRight
        className="size-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5"
        strokeWidth={2}
        aria-hidden
      />
    </>
  );
}
